(() => {
  if (window.__snugPremiumSearchLoaded) return;
  window.__snugPremiumSearchLoaded = true;

  const mobileMedia = window.matchMedia('(max-width: 768px)');

  const normalizeSearchQuery = (value) => {
    const term = value.trim();
    return /^(sofa|couch) covers?$/i.test(term) ? `"${term}"` : term;
  };

  const ensureSearchCartIsolationStyle = () => {
    if (document.getElementById('snug-search-cart-isolation')) return;
    const style = document.createElement('style');
    style.id = 'snug-search-cart-isolation';
    style.textContent = `
      @media (min-width: 769px) {
        html:has(header-search .popup-search-show:not(.search-hidden)) .header__minicart .minicart__wrapper,
        html:has(header-search .popup-search-show:not(.search-hidden)) .minicart__wrapper {
          transform: translate3d(100%, 0, 0) !important;
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
        html:has(header-search .popup-search-show:not(.search-hidden)) .snug-cart-backdrop,
        html:has(header-search .popup-search-show:not(.search-hidden)) .header__minicart .overlay::after,
        html:has(header-search .popup-search-show:not(.search-hidden)) .minicart.overlay::after {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const closeCartBeforeSearch = () => {
    const root = document.documentElement;
    document.querySelectorAll('.minicart__wrapper.open').forEach((drawer) => {
      drawer.classList.remove('open');
    });
    root.classList.remove('open-minicart');
    document.body.classList.remove('open-minicart');

    root.classList.remove('open-drawer');
    document.body.classList.remove('open-drawer');
  };

  const closeSearch = (search) => {
    if (!search) return;
    const popup = search.querySelector('.popup-search-form');
    const input = search.querySelector('input[type="search"]');

    popup?.classList.remove('popup-search-show', 'open');
    popup?.classList.add('search-hidden', 'invisible');
    popup?.setAttribute('aria-hidden', 'true');
    popup?.style.setProperty('pointer-events', 'none');

    search.classList.remove('snug-search-has-query');
    if (input) {
      input.value = '';
      input.setAttribute('aria-expanded', 'false');
      input.blur();
    }

    document.documentElement.classList.remove('open-search');
    document.body.classList.remove('open-search');
  };

  const dismissProductQuickview = () => {
    document.querySelectorAll('.tingle-modal--visible').forEach((modal) => {
      if (!modal.querySelector('.product-quickview__content')) return;
      const closeButton = modal.querySelector('.tingle-modal__close, [aria-label="Close"], [data-modal-close]');
      closeButton?.click();
    });
  };

  const positionSearch = (search) => {
    const popup = search.querySelector('.popup-search-form');
    if (!popup) return;
    const header = search.closest('.section-header') || document.querySelector('.section-header') || document.querySelector('header');
    const bottom = Math.max(8, Math.round(header?.getBoundingClientRect().bottom || 96));
    popup.style.setProperty('--snug-search-top', `${bottom + 10}px`);
    search.style.setProperty('--snug-search-overlay-top', `${bottom}px`);
  };

  const enhanceSearch = (search) => {
    if (mobileMedia.matches) return;
    if (search.classList.contains('snug-search-enhanced')) return;
    search.classList.add('snug-search-enhanced');

    const popup = search.querySelector('.popup-search-form');
    const content = popup?.querySelector('.content-search-form');
    const input = search.querySelector('input[type="search"]');
    const form = search.querySelector('form[role="search"]');
    const searchButton = search.querySelector('.search__button');
    if (!popup || !content || !input) return;

    const heading = document.createElement('div');
    heading.className = 'snug-search-head';
    heading.innerHTML = `
      <div>
        <span class="snug-search-head__eyebrow">Snug &amp; Homely search</span>
        <strong class="snug-search-head__title">Find your perfect home layer</strong>
        <p class="snug-search-head__text">Search by sofa size, material, colour or room.</p>
      </div>
      <button class="snug-search-close" type="button" aria-label="Close search">
        <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
          <path d="M4 4l12 12M16 4 4 16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        </svg>
      </button>`;
    content.prepend(heading);

    const syncQueryState = () => {
      search.classList.toggle('snug-search-has-query', input.value.trim().length > 0);
      positionSearch(search);
    };

    const openSearch = ({ focus = false } = {}) => {
      closeCartBeforeSearch();
      dismissProductQuickview();

      popup.classList.remove('search-hidden', 'invisible');
      popup.classList.add('popup-search-show');
      popup.removeAttribute('aria-hidden');
      popup.style.removeProperty('pointer-events');

      syncQueryState();
      if (focus) {
        window.setTimeout(() => input.focus({ preventScroll: true }), 30);
      }
    };

    const closeButton = heading.querySelector('.snug-search-close');
    const handleClose = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeSearch(search);
    };
    closeButton?.addEventListener('pointerdown', handleClose, true);
    closeButton?.addEventListener('click', handleClose, true);

    search.addEventListener('click', (event) => {
      if (event.target !== search) return;
      if (!popup.classList.contains('popup-search-show')) return;
      event.preventDefault();
      event.stopPropagation();
      closeSearch(search);
    }, true);

    searchButton?.addEventListener('click', (event) => {
      // Always isolate search from any cart/minicart handlers attached by the base theme.
      // Clicking the header search icon must only open/search, never trigger cart navigation.
      closeCartBeforeSearch();
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const isOpen = popup.classList.contains('popup-search-show')
        && !popup.classList.contains('search-hidden');
      if (isOpen && input.value.trim()) {
        form?.requestSubmit();
      } else {
        openSearch({ focus: true });
      }
    }, true);

    form?.addEventListener('submit', (event) => {
      closeCartBeforeSearch();
      event.stopPropagation();
      input.value = normalizeSearchQuery(input.value);

      // Keep search submissions pinned to Shopify's search route even if another
      // theme/app listener mutates the form action.
      form.setAttribute('action', '/search');
      form.setAttribute('method', 'get');
    }, true);

    content.addEventListener('click', (event) => {
      const productLink = event.target.closest('a[href*="/products/"]');
      if (productLink) {
        event.stopPropagation();
        closeSearch(search);
        return;
      }

      const quickviewButton = event.target.closest('button-quickview, .product-item__button-quickview');
      if (!quickviewButton) return;
      event.preventDefault();
      event.stopPropagation();
      const productCard = quickviewButton.closest('.product-item');
      const fallbackLink = productCard?.querySelector('a[href*="/products/"]');
      if (fallbackLink?.href) window.location.assign(fallbackLink.href);
    });

    input.addEventListener('input', syncQueryState);
    input.addEventListener('focus', () => openSearch());
    input.addEventListener('click', () => openSearch());
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSearch(search);
    });

    new MutationObserver(() => {
      if (popup.classList.contains('popup-search-show')) {
        closeCartBeforeSearch();
        positionSearch(search);
      }
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });

    syncQueryState();
  };

  const delegatedCloseSearch = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const closeButton = target.closest('.snug-search-close');
    if (!closeButton) return;

    const search = closeButton.closest('header-search');
    if (!search) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    closeSearch(search);
  };

  document.addEventListener('pointerdown', delegatedCloseSearch, true);
  document.addEventListener('click', delegatedCloseSearch, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('header-search.snug-search-enhanced').forEach((search) => {
      const popup = search.querySelector('.popup-search-form.popup-search-show');
      if (popup) closeSearch(search);
    });
  }, true);

  const bindSearchQueryNormalization = () => {
    document.querySelectorAll('form[role="search"]').forEach((form) => {
      if (form.dataset.snugSearchNormalization === 'true') return;
      form.dataset.snugSearchNormalization = 'true';
      form.addEventListener('submit', () => {
        const queryInput = form.querySelector('input[name="q"]');
        if (queryInput) queryInput.value = normalizeSearchQuery(queryInput.value);
      }, true);
    });
  };

  const init = () => {
    ensureSearchCartIsolationStyle();
    bindSearchQueryNormalization();
    document.querySelectorAll('header-search').forEach(enhanceSearch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('resize', () => document.querySelectorAll('header-search.snug-search-enhanced').forEach(positionSearch), { passive: true });
  window.addEventListener('scroll', () => document.querySelectorAll('header-search.snug-search-enhanced').forEach((search) => {
    if (search.querySelector('.popup-search-show')) positionSearch(search);
  }), { passive: true });

  mobileMedia.addEventListener?.('change', (event) => {
    if (!event.matches) {
      init();
      return;
    }
    document.querySelectorAll('header-search.snug-search-enhanced .popup-search-form').forEach((popup) => {
      popup.classList.remove('popup-search-show');
      popup.classList.add('search-hidden');
    });
  });
})();
